import Spinner from "../../Components/spinner/Spinner";
import {COLOR_SCHEME} from "../colorSheme";

const LoaderWholePage = () => {
  return (
    <div
      className="row jcc aic"
      style={{
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: "10000",
        opacity: "30%",
        backgroundColor: COLOR_SCHEME.GREY,
      }}
    >
      <Spinner />
    </div>
  );
};

export default LoaderWholePage;
